



































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Params from './Params.vue';
import Comments from './Comments.vue';
import Detail from './Detail.vue';

@Component({
  components: {
    Params,
    Comments,
    Detail,
  },
})
export default class GoodsContent extends Vue {
  get load() {
    return this.$store.state.goodsDetail.comments.length > 0;
  }
  @Prop() public scrollTop!: number;
  private tabIndex: number = 0;
  private offset: number[] = [];
  private opacity: string = '';
  private opacityMenu: string = 'opacity: 0; display: none';
  @Watch('scrollTop')
  public changeScroll() {
    const top = this.scrollTop > 250 ? 250 : this.scrollTop;
    let opacity = (top / 250).toFixed(2);
    const bg = 'rgba(255, 255, 255, ' + opacity + ')';
    if (this.load && this.offset.length === 0) {
      this.offset.push(0);
      setTimeout(() => {
        this.offset.push(this.$refs.comments.$el.offsetTop - 32);
        this.offset.push(this.$refs.detail.$el.offsetTop - 32);
      }, 1e2);
    }
    if (this.offset.length > 0) {
      if (this.scrollTop > this.offset[2]) {
        this.tabIndex = 2;
      } else if (this.scrollTop > this.offset[1]) {
        this.tabIndex = 1;
      } else {
        this.tabIndex = 0;
      }
    }
    this.opacity = 'background-color: ' + bg;
    if (top === 0) {
      opacity = '0; display: none';
    }
    this.opacityMenu = 'opacity: ' + opacity;
  }

  private tabChecked(tab: number) {
    if (this.offset.length > 0) {
      let top = this.offset[tab];
      if (top !== 0) {
        top ++;
      }
      this.$parent.$el.scrollTop = top;
    }
    this.tabIndex = tab;
  }
  private back() {
    this.$router.back();
  }
  private share() {
    console.log('share: ', this.$route.query.gid);
  }
}
